define(['t3', 'hy/hy-module', 'hy/hy-utils', 'lodash', 'events', 'jquery', 'lib/velocity/velocity', 'conditioner', 'core/services/expander'], function(T3, BaseModule, hyutils, lodash, EVENTS, $, Velocity, conditioner) {

    'use strict';

    return BaseModule.addModule('common/modules/opl-expander', function(context) {
        var options = context.element.options;
        var _options;
        var moduleEl,
            expanderService,
            scrollingOffset = 0,
            checkHeaderState = false;

        var htmlAndBody;


        function scrollToTop(scrollstate) {

            context.broadcast(EVENTS.modules.header.recalculateMenu);
            var fixheaderHeight = parseInt($('#header').attr('data-fixed'));

            if (isNaN(fixheaderHeight) !== false) {
                fixheaderHeight = 0;
            }

            if ((_options.scrollToSelected === false && scrollstate === true) || _options.scrollToSelected) {

                var section = expanderService.getCurrentSection();

                var prevSection = $(moduleEl).find('.' + _options.parentClass + '.is-expanded');

                var offset = 0;

                // if there was an open section when another was opened
                if (prevSection.length) {


                    // calculate offset to scroll to
                    offset = section.offset().top - $(prevSection.find(_options.contentSelector)[0]).outerHeight(true);


                    // // if triggered section was below previously open section
                    if (prevSection.offset().top > section.offset().top) {
                        // scroll to the triggered section
                        offset = section.offset().top;
                    }
                    // else, scroll to the triggered section
                } else {
                    offset = section.offset().top;
                }


                if (!checkHeaderState) {
                    checkHeaderState = true;
                    scrollingOffset = fixheaderHeight;
                }


                var test = offset - scrollingOffset;

                Velocity(htmlAndBody, 'scroll', {
                    offset: test,
                    duration: _options.duration,
                    easing: 'easeInOut' + _options.easing,
                    complete: function() {
                        checkHeaderState = false;
                    }
                });
            }
        }

        function mobileExpander(state) {
            $.each($(moduleEl).find('.' + _options.parentClass), function(i, el) {
                var $el = $(el),
                    $currentState = $el.hasClass(_options.expandedClass),
                    $elTrigger = $el.find(_options.triggerSelector).attr('id');

                //save initial state;
                if ($currentState) {
                    $el.attr('data-initial', _options.expandedClass);
                }

                if (state && $currentState) {
                    expanderService.collapseCurrentSection($elTrigger);
                } else if (!state && !$currentState && $el.attr('data-initial') === _options.expandedClass) {

                    $el.addClass(_options.expandedClass);
                    $el.find(_options.contentSelector).show();

                }
            });
        }

        function stopHeader() {

            //if (header.length && context.application.isStarted(headerModule.moduleName)) {
            //context.broadcast(EVENTS.modules.oplExpander.hideHeader, true, header.attr('id'));
            //context.application.stop(header, headerModule.getModulePath(), headerModule);
            //}
        }

        return {
            init: function() {
                moduleEl = context.getElement();

                htmlAndBody = $('html, body');

                expanderService = context.getService('expander').create(moduleEl, options);

                _options = expanderService.getOptions();


                //use radio buttons to manage expander content.
                if (_options.switchTrigger) {
                    expanderService.init(['change']);
                }

                //use standard event [click]
                else {
                    expanderService.init(['click'], scrollToTop);
                }


                if (_options.mobileExpander === 'hide') {
                    conditioner.addConditionMonitor('media:{eq-small}', function(state) {
                        mobileExpander(state);
                    });
                    $(window).on('resize', _.debounce(function() {
                        conditioner.addConditionMonitor('media:{eq-small}', function(state) {
                            mobileExpander(state);
                        });
                    }, 400));
                }

            },

            destroy: function() {
                expanderService.destroy(moduleEl, options);
                expanderService = null;

                moduleEl = null;
            },

            messages: [
                EVENTS.modules.expander.triggered,
                EVENTS.modules.expander.toggle,
                EVENTS.modules.expander.open,
                EVENTS.modules.expander.close,
                EVENTS.modules.expander.next,
                EVENTS.modules.expander.prev,
                EVENTS.modules.expander.openall,
                EVENTS.modules.expander.closeall,
                EVENTS.modules.expander.loadHash,
                EVENTS.modules.expander.animation.started,
                EVENTS.modules.expander.animation.ended,
                EVENTS.modules.expander.reinit
            ],

            onmessage: function(name, data) {
                switch (name) {
                    case EVENTS.modules.expander.triggered:
                        stopHeader();
                        break;
                    case EVENTS.modules.expander.toggle:
                        expanderService.toggleSection(data);
                        break;
                    case EVENTS.modules.expander.open:
                        expanderService.openDirectSelection(data);
                        break;
                    case EVENTS.modules.expander.close:
                        expanderService.collapseDirectSelection(data);
                        break;
                    case EVENTS.modules.expander.next:
                        expanderService.nextSection();
                        break;
                    case EVENTS.modules.expander.prev:
                        expanderService.prevSection();
                        break;
                    case EVENTS.modules.expander.openall:
                        expanderService.expandAllSection(data);
                        break;
                    case EVENTS.modules.expander.closeall:
                        expanderService.collapseAllSection(data);
                        break;
                    case EVENTS.modules.expander.loadHash:
                        expanderService.loadByHash(data);
                        break;
                    case EVENTS.modules.expander.animation.started:
                        scrollToTop(data);
                        break;
                    case EVENTS.modules.expander.animation.ended:
                        //startHeader();
                        break;
                    case EVENTS.modules.expander.reinit:
                        expanderService.reloadmMdule();
                        break;
                    default:
                        break;
                }
            }
        };
    });
});